import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Gaegu']
  }
});
